// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__j6KFV","subheading":"styles_subheading__HK7Ul","firstWord":"styles_firstWord__fWKBS"};